import React from "react";
import { Checkbox, Icon } from "antd";
import NumberFormat from "../../../../NumberFormat";

/* add_displays / delete_displays — lista de pantallas con selección parcial. */
export default function DisplaysProposal({ action, payload, checkedIds, onToggle, disabled, t }) {
  const labelKey = action === "add_displays"
    ? "ChatbotProposalAdd"
    : "ChatbotProposalDelete";
  const preview = payload.preview || [];

  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t(labelKey)}</p>
      {preview.map(display => (
        <label key={display.id} className="chatbot-proposal-display-row">
          <Checkbox
            checked={checkedIds.includes(display.id)}
            onChange={() => onToggle(display.id)}
            disabled={disabled}
          />
          {display.picture_url ? (
            <img
              className="chatbot-proposal-display-thumb"
              src={display.picture_url}
              alt={display.name}
            />
          ) : (
            <span className="chatbot-proposal-display-thumb chatbot-proposal-display-thumb--empty">
              <Icon type="picture" />
            </span>
          )}
          <span className="chatbot-proposal-display-info">
            <span className="chatbot-proposal-display-name">{display.name}</span>
            <span className="chatbot-proposal-display-loc">
              {display.administrative_area_level_2}, {display.administrative_area_level_1}
            </span>
          </span>
          <span className="chatbot-proposal-display-price">
            {display.purchase_type === "programmatic" ? (
              <>
                <NumberFormat
                  value={display.cpmi}
                  currency={display.price_currency}
                /> CPM
              </>
            ) : (
              <>
                <NumberFormat
                  value={display.price_per_day}
                  currency={display.price_currency}
                />/día
              </>
            )}
          </span>
        </label>
      ))}
      {preview.length > 0 && (
        <p className="chatbot-proposal-counter">
          {checkedIds.length} / {preview.length}
        </p>
      )}
    </div>
  );
}
